import { Box, Text, Group, Badge } from '@mantine/core';
import { IconRobot } from '@tabler/icons-react';
import { AgentTabs } from '@/components/Agent';

interface CopilotSidebarProps {
  roomCode: string;
  onEndMeeting: () => void;
  isConnected: boolean;
}

export const CopilotSidebar = ({
  roomCode,
  onEndMeeting,
  isConnected,
}: CopilotSidebarProps) => {
  return (
    <Box
      style={{
        width: 450,
        backgroundColor: 'white',
        borderLeft: '1px solid #e9ecef',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      {/* Header */}
      <Box
        style={{
          padding: '12px 16px',
          borderBottom: '1px solid #e9ecef',
          backgroundColor: '#f8f9fa',
        }}
      >
        <Group gap="xs" justify="space-between">
          <Group gap="xs">
            <IconRobot size={18} color="#228be6" />
            <Text fw={600} size="sm">
              Copilot
            </Text>
          </Group>
          <Badge
            size="sm"
            variant="dot"
            color={isConnected ? 'green' : 'gray'}
          >
            {isConnected ? 'Conectado' : 'Desconectado'}
          </Badge>
        </Group>
      </Box>

      {/* Content */}
      <Box style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
        <AgentTabs
          roomCode={roomCode}
          onEndMeeting={onEndMeeting}
          isConnected={isConnected}
        />
      </Box>
    </Box>
  );
};
